export const PHONE_MASK = '(999) 999 - 9999';
